module.exports = __webpack_public_path__ + "img/empreendimento-logo-32.71e5b856.png";